import React from "react";
import ReactECharts from "@/components/EChartsReact";

const BubblePlot = (props) => {

    const getOption = () => {
        return {
            backgroundColor: '#ffffff',
            title: {
                text: props.title,
                left: 'center',
                top: '2%',
                textStyle: {
                    color: '#396598',
                    fontSize: 14
                }
            },
            tooltip: props.showTip ? {
                trigger: 'item',
                formatter: function(params) {

                    const facilityText = params.data[5] ? `Facility: ${params.data[5]}<br/>` : '';

                    return `
                            ${facilityText}
                            Category: ${params.data[3]}<br/>
                            Year: ${params.data[0]}<br/>
                            EUI: ${params.data[1]}<br/>
                            Size: ${params.data[2]}`;
                }
            } : false,
            xAxis: {
                name: props.xLabel,
                type: 'category',
                nameLocation: 'middle',
                nameGap: 30,
                axisLabel: {
                    hideOverlap: true,
                    rotate: 0,
                    fontSize: 12
                }
            },
            yAxis: {
                name: props.yLabel,
                type: 'value',
                nameLocation: 'middle',
                nameGap: 35,
                scale: true,
                axisLabel: {
                    fontSize: 12
                }
            },
            legend: {
                data: ['Current', 'Other'],
                top: 50
            },
            series: [{
                type: 'scatter',
                data: props.data.map(item => {
                    return ([
                        item.xAxis,
                        item.yAxis,
                        item.size,
                        item.type,
                        item.isCurrent,
                        item.facilityName
                    ])
                }),
                symbolSize: function (data) {
                    // 根据size字段计算气泡大小，可以调整系数来改变气泡大小范围
                    return Math.sqrt(Math.sqrt(data[2])) / 2;
                },
                itemStyle: {
                    color: function(params) {
                        return params.data[4] ? '#70ad47' : '#1890ff';
                    },
                    opacity: 0.65
                },
                emphasis: {
                    focus: 'series',
                    label: {
                        show: false
                    }
                }
            }],
            grid: {
                top: '20%',
                left: 60,
                right: 20,
                bottom: 40,
                containLabel: true
            }
        };
    };

    return (
            <ReactECharts
                option={getOption()}
                style={{ 
                    width: '100%',
                    height: 'auto',
                    aspectRatio: '2 / 1',
                    borderRadius: '8px',
                    overflow: 'hidden'
                }}
                notMerge={true}
                lazyUpdate={true}
            />
    );
};

export default BubblePlot;
